class VideoCard extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.playButton = null;
    this.isPlaying = false;
    this.played = false;
    this._onPlayClick = (e) => this.togglePlaybackVideo();
    this._onEnded = () => this.resetPlayback();
  }

  connectedCallback() {
    this.video = this.querySelector("video");
    this.playButton = this.querySelector(".toggle-container");
    if (!this.video || !this.playButton) return;

    this.playButton.addEventListener("click", this._onPlayClick);
    this.video.addEventListener("ended", this._onEnded);
  }

  disconnectedCallback() {
    if (!this.video || !this.playButton) return;

    this.playButton.removeEventListener("click", this._onPlayClick);
    this.video.removeEventListener("ended", this._onEnded);
  }
  togglePlaybackVideo() {
    if (!this.video) return;
    this.played = true;
    this.stopAllExcept(this);

    if (this.isPlaying) {
      this.video.pause();
      this.playButton.style.opacity = "1";
      this.isPlaying = false;
    } else {
      this.video.play();
      this.playButton.style.opacity = "0";
      this.isPlaying = true;
    }
  }

  resetPlayback() {
    this.isPlaying = false;
    this.playButton.style.opacity = "1";
  }

  stopAllExcept(currentCard) {
    document.querySelectorAll("video-card").forEach((card) => {
      if (card !== currentCard && card.video && !card.video.paused) {
        card.video.pause();
        card.playButton && (card.playButton.style.opacity = "1");
        card.isPlaying = false;
      }
    });
  }
}

// Define the custom element
customElements.define("video-card", VideoCard);

// Read more functionality for product description
document.addEventListener("DOMContentLoaded", function () {
  const readMoreButtons = document.querySelectorAll("[data-read-more-toggle]");

  if (readMoreButtons.length === 0) return;

  readMoreButtons.forEach((button) => {
    const wrapper = button.closest(".product__long-description-wrapper");
    const content = wrapper?.querySelector("[data-read-more-content]");

    if (!content) return;

    // Temporarily remove line-clamp to measure full height
    const originalDisplay = content.style.display;
    content.style.display = "block";
    const fullHeight = content.scrollHeight;
    content.style.display = originalDisplay || "";

    // Calculate 2-line height
    const lineHeight =
      parseFloat(window.getComputedStyle(content).lineHeight) || 24;
    const fontSize =
      parseFloat(window.getComputedStyle(content).fontSize) || 16;
    const twoLineHeight = lineHeight * 2;

    // Only show button if content exceeds 2 lines
    if (fullHeight <= twoLineHeight + 5) {
      // 5px tolerance
      button.style.display = "none";
      return;
    }

    button.addEventListener("click", function () {
      const isExpanded = content.classList.toggle("expanded");
      button.setAttribute("aria-expanded", isExpanded);
    });
  });
});
class CustomSorting extends HTMLElement {
  constructor() {
    super();
    this.selectElement = null;
    this._onChange = (e) => this.handleSortChange(e);
  }

  connectedCallback() {
    this.trigger = this.querySelector(".sort-trigger");
    this.popup = this.querySelector("#sortPopup");
    this.closeBtn = this.querySelector(".sort-close");
    this.realSelect = document.querySelector("#SortBy");

    this.trigger.addEventListener("click", () => {
      this.popup.classList.toggle("active");
      this.trigger.classList.toggle("active");
    });
    this.querySelectorAll(".sort-radio input").forEach((radio) => {
      radio.addEventListener("change", () => {
        this.realSelect.value = radio.value;
        this.realSelect.dispatchEvent(new Event("change", { bubbles: true }));
        this.popup.classList.remove("active");
        this.trigger.classList.remove("active");
        this.trigger.querySelector("span").textContent = radio.dataset.name || radio.nextElementSibling.textContent;
      });
    });

    document.addEventListener("click", (e) => {
      if ( !this.popup.contains(e.target) && !this.trigger.contains(e.target)) {
        this.popup.classList.remove("active");
        this.trigger.classList.remove("active");
      }
    });
    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get("sort_by") || "Soroten op";
    if(!params.get("sort_by")) {
      this.trigger.querySelector("span").textContent = "Sorteren op";
      this.querySelectorAll(".sort-radio input").forEach((radio) => {
        radio.checked = false;
      });
    }
  }
}

customElements.define("custom-sorting", CustomSorting);

class CustomSortingMobile extends HTMLElement {
  constructor() {
    super();
    this.selectElement = null;
    this._onChange = (e) => this.handleSortChange(e);
  }

  connectedCallback() {
    this.trigger = this.querySelector(".sort-trigger");
    this.popupMobile = this.querySelector("#sortPopupMobile");
    this.closeBtn = this.querySelector(".sort-close");
    this.realSelect = document.querySelector("#SortBy-mobile");

    this.trigger.addEventListener("click", () => {
      this.popupMobile.classList.toggle("active");
      this.trigger.classList.toggle("active");
    });

    this.querySelectorAll("input.custom-sort-mobile-radio").forEach((radio) => {
      radio.addEventListener("change", (e) => {
        this.realSelect.value = radio.value;
        this.realSelect.dispatchEvent(new Event("change", { bubbles: true }));
        this.popupMobile.classList.remove("active");
        this.trigger.classList.remove("active");
        this.trigger.querySelector("span").textContent =
          radio.dataset.name || radio.nextElementSibling.textContent;
      });
    });
    document.addEventListener("click", (e) => {
      if (!this.popupMobile.contains(e.target) && !this.trigger.contains(e.target) ) {
        this.popupMobile.classList.remove("active");
        this.trigger.classList.remove("active");
      }
    });

    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get("sort_by") || "Soroten op";
    if (!params.get("sort_by")) {
      this.trigger.querySelector("span").textContent = "Sorteren op";
      this.querySelectorAll(".sort-radio input").forEach((radio) => {
        radio.checked = false;
      });
    }
  }
}

customElements.define("custom-sorting-mobile", CustomSortingMobile);
class MultipleAddToCart extends HTMLElement {
  constructor() {
    super();
    this.product_ids = JSON.parse(this.dataset.productIds || "[]");
    this.button = this.querySelector("div[add-to-cart-btn]");
  }
  connectedCallback() {
    if (!this.product_ids || this.product_ids.length === 0) {
      console.warn("No product IDs found for Add to Cart.");
      return;
    }
    const items = [];
    this.product_ids.product_id.forEach((id) => {
      items.push({ id: id, quantity: 1 });
    });

    this.button.addEventListener("click", () => this.addToCart(items));
  }
  async addToCart(items) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    });
    if (!response.ok) {
      console.error("Add failed");
      return;
    }

    await this.refreshCartDrawer();
  }
  async refreshCartDrawer() {
    console.log("Refreshing cart drawer...");
    const response = await fetch("/?sections=cart-drawer,cart-icon-bubble");

    const sections = await response.json();

    const bubble = document.getElementById("cart-icon-bubble");
    const drawer = document.querySelector("cart-drawer");
    const drawerInner = drawer?.querySelector("#CartDrawer");

    if (bubble && sections["cart-icon-bubble"]) {
      bubble.innerHTML = sections["cart-icon-bubble"];
    }

    if (drawer && sections["cart-drawer"]) {
      drawerInner.innerHTML = this.getSectionDOM(sections["cart-drawer"], "#CartDrawer").innerHTML;
      document.querySelector("body").classList.add("overflow-hidden");
      drawer.classList.remove('is-empty');
      drawer.classList.add("animated", "active");
    }
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
}
customElements.define("multiple-add-to-cart", MultipleAddToCart);

